import loadable from "@loadable/component";
import Validator, { RequiredRule } from "devextreme-react/validator";
import { InputSwitch } from "primereact/inputswitch";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import { messageBox2 } from "../components/Common/MessageBox";
import { useFocus2 } from "../components/Hooks/useFocus";
import validationGroup from "../components/Hooks/useValidationGroup";
import { showNotify } from "../lib/utils";
import { NOTIFY_TYPES } from "../lib/utilsConst";
//DESCRIPCIÓN: LOGIN

const Button = loadable(() => import("devextreme-react/button"));
const TextBox = loadable(() => import("devextreme-react/text-box"));
const AGTXXI103 = loadable(() => import("../components/AGTXXI/AGTXXI103"));
const ValidationGroup = loadable(() => import("devextreme-react/validation-group"));

export const Login = (props) => {
  const { login, redirectLocation, setCookie, isAuthenticated } = props.auth;
  const { t, i18n } = useTranslation(["login", "message"]);
  const [inputRefs, setFocus, moveNext] = useFocus2(2);
  const [isProcessing, setIsProcessing] = useState(false);

  const validationGroupRef = useRef("");
  const [userCode, setUserCode] = useState("");
  const [password, setPassword] = useState("");
  const [isAGTXXI103Visible, setIsAGTXXI103Visible] = useState(false);
  const [english, setEnglish] = useState(i18n.language === "en-US");

  const handleUserChange = (event) => {
    const value = event.event.target.value;
    setUserCode(value ? value.toUpperCase() : value);
  };

  const handleUserOnEnter = () => {
    moveNext(0);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.event.target.value);
  };

  const handleEnterKeyPwd = async () => {
    const isValid = await validationGroup(validationGroupRef);
    if (!isValid) return;

    setIsProcessing(true);
    await iniciarSesion(userCode, password);
    setIsProcessing(false);
  };

  const iniciarSesion = async (userCode, password, loginAfterPwdChanged = false) => {
    const { hasError, message, data } = await login(userCode, password);

    if (hasError) {
      showNotify(NOTIFY_TYPES.ERROR, message);
      return;
    }

    if (data) {
      const { canAccess, messageValidation, authenticationResponse, requireUpdatePwd, isOptionalUpdate } = data;

      const newMessageValidation = messageValidation?.trim()?.replace(/(?:\r\n|\r|\n)/g, "<br>") ?? "";

      if (!canAccess) {
        await messageBox2({ title: t("message:MSG_INFORMATION"), header: newMessageValidation, accept: t("message:MSG_OK") });
        return;
      }

      if (requireUpdatePwd) {
        if (isOptionalUpdate) {
          if (!loginAfterPwdChanged) {
            const accepted = await messageBox2({
              title: t("message:MSG_INFORMATION"),
              header: newMessageValidation,
              accept: t("message:MSG_OK"),
              cancel: t("message:MSG_CANCEL"),
            })
              .then((r) => r.result)
              .catch(() => false);

            if (accepted) {
              setIsAGTXXI103Visible(true);
              return;
            }
          }
        } else {
          await messageBox2({
            title: t("message:MSG_INFORMATION"),
            header: newMessageValidation,
            accept: t("message:MSG_OK"),
          }).catch(() => true);
          setIsAGTXXI103Visible(true);
          return;
        }
      }

      setCookie(authenticationResponse);
      redirectLocation();
    }
  };

  const handleClickAcceptar = async (event) => {
    const isValid = await validationGroup(validationGroupRef);
    if (!isValid) return;

    setIsProcessing(true);
    await iniciarSesion(userCode, password);
    setIsProcessing(false);
  };

  async function setLanguaje(e) {
    await i18n.changeLanguage(english ? "es-MX" : "en-US");
    setEnglish(["en-US", "en"].includes(i18n.language));
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setTimeout(() => setFocus(0)), []);

  const loginAfterPwdChanged = async (userCode, password) => {
    iniciarSesion(userCode, password, true);
  };

  if (isAuthenticated()) return <Redirect to="/" />;

  return (
    <>
      <div className="login-container">
        <div>
          <div className="login-logo-container">
            <div className="text-center">
              <img className="login-logo" src="assets/layout/images/pages/prisma-logo-login.png" alt="Logotipo Prisma" />
            </div>
          </div>
          <div className="login-main-text-container">
            <div className="login-main-text">
              <p className="text-center">GLOBAL TRADE XXI</p>
            </div>
          </div>
          <ValidationGroup ref={validationGroupRef}>
            <div className="login-center-objets login-username-text-container">
              <TextBox
                ref={inputRefs[0]}
                value={userCode}
                inputAttr={{ style: "text-transform: uppercase" }}
                style={{ background: "White" }}
                className="login-username-size"
                placeholder={t("AGTXXI001LblUsuarioText")}
                id="user"
                name="user"
                onChange={handleUserChange}
                onEnterKey={handleUserOnEnter}
                disabled={isProcessing}
                maxLength={15}
              >
                <Validator>
                  <RequiredRule message={t("AGTXXI001LblIngresaUsuario")} />
                </Validator>
              </TextBox>
            </div>
            <div className="login-center-objets login-password-text-container">
              <TextBox
                value={password}
                ref={inputRefs[1]}
                style={{ background: "WHITE" }}
                className="login-username-size"
                placeholder={t("AGTXXI001LblPasswordText")}
                id="password"
                name="password"
                mode="password"
                onChange={handlePasswordChange}
                onEnterKey={handleEnterKeyPwd}
                disabled={isProcessing}
                maxLength={20}
              />
            </div>
          </ValidationGroup>
          {/* <div className="login-center-objets login-password-text-container">
          <SelectBox dataSource={empresas} valueExpr="ID" displayExpr="Name" style={{ background: "WHITE" }} className="login-username-size" placeholder={t("AGTXXI001LblEmpresaText")} />
        </div>
        <div className="login-center-objets login-password-text-container">
          <SelectBox visible={false} style={{ background: "WHITE" }} className="login-username-size" placeholder={t("AGTXXI001LblPlantaText")} />
        </div> */}
          <div className="login-center-objets login-languaje-container">
            <label className="login-languaje-label">{t("AGTXXIIdiomaSpanish")}</label>
            <InputSwitch className="login-languaje-button-margin" checked={english} onChange={setLanguaje} disabled={isProcessing} />
            <label className="login-languaje-label">{t("AGTXXIIdiomaEnglish")}</label>
          </div>
          <div className="login-center-objets login-button-container">
            {isProcessing ? (
              <Button
                className="login-button"
                type="danger"
                style={{ width: "12rem" }}
                disabled={isProcessing}
                render={() => <i className={"pi pi-spin pi-spinner"} style={{ fontSize: "1.1rem" }}></i>}
              ></Button>
            ) : (
              <Button className="login-button" icon="check" type="danger" text={t("AGTXXI001SignIn")} style={{ width: "12rem" }} onClick={handleClickAcceptar} />
            )}
          </div>
        </div>
      </div>
      {isAGTXXI103Visible && <AGTXXI103 visible={isAGTXXI103Visible} userCode={userCode} isLogin hidden={() => setIsAGTXXI103Visible(false)} loginAfterPwdChanged={loginAfterPwdChanged} />}
    </>
  );
};
